"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var BackThick = function BackThick(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "back-thick"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.4 8.86h-14.080l4.56-4.56c0.237-0.206 0.386-0.509 0.386-0.846 0-0.619-0.501-1.12-1.12-1.12-0.337 0-0.639 0.149-0.845 0.384l-0.001 0.001-6.5 6.48c-0.103 0.105-0.184 0.232-0.238 0.373l-0.002 0.007c-0.052 0.124-0.082 0.269-0.082 0.42s0.030 0.296 0.084 0.427l-0.003-0.007c0.056 0.148 0.137 0.275 0.24 0.38l-0-0 6.5 6.48c0.202 0.202 0.482 0.326 0.79 0.326s0.588-0.125 0.79-0.326l-0 0c0.202-0.202 0.326-0.482 0.326-0.79s-0.125-0.588-0.326-0.79l-4.56-4.56h14.080c0.63 0 1.14-0.51 1.14-1.14s-0.51-1.14-1.14-1.14v0z"
  }));
};
var _default = exports["default"] = BackThick;